const initState = {

}

export default (state = initState, action) => {
  switch (action.type) {
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/laptopQuizPageReducer.js